import Dashboard from "../layouts/Dashboard/Dashboard.js";
import Pages from "../layouts/Pages/Pages.jsx";

var indexRoutes = [
  // { path: "/login", name: "Login", component: Pages },
  { path: "/", name: "Home", component: Dashboard }
];

export default indexRoutes;
